(function () {
    'use strict';

    angular
        .module('initiativeUpdateStatusControllers')
        .controller('InitiativeUpdateStatusController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'activeProcess']

    function Controller($scope, $state, topBarService, activeProcess) {
        topBarService.setTitleAndIcon('Business Planning - Initiative Status', 'fa fa-compass');

        if (!_.isObject(activeProcess) || _.isUndefined(activeProcess.GovernanceProcessID)) {
            $state.go('initiativeUpdateStatusOwnerList.noActiveProcess', {}, { location: 'replace' });
        }
    }
})();